import { VehicleRowGroup } from 'src/pages/ConvenienceDispatches/adapter';

/**
 * 日付変更や再取得で消えた rowId を展開 state から除去する。
 * 残すと「別日の同じ rowId が展開済み」になる（P2b の pruneSelectedUnassignedIds と同じ問題）。
 * 変化が無ければ同じ Set 参照を返す（返り値を state に入れるので、毎回新しい Set を
 * 返すと再レンダーが止まらない）。
 */
export function pruneExpandedRowIds(
  prev: ReadonlySet<string>,
  rowGroups: readonly VehicleRowGroup[],
): Set<string> {
  if (prev.size === 0) return prev as Set<string>;
  const validIds = new Set<string>();
  rowGroups.forEach((group) => group.rows.forEach((row) => validIds.add(row.rowId)));
  let changed = false;
  const next = new Set<string>();
  prev.forEach((rowId) => {
    if (validIds.has(rowId)) next.add(rowId);
    else changed = true;
  });
  return changed ? next : (prev as Set<string>);
}
